import React from 'react';
import { useSession } from '@/auth/index';
import { useAppConstantsContext } from '@/context/AppConstants';
import { Text, Icons, Box, Divider } from '@/theme/index';
import { CopyTooltip } from '@/utils/index';
import {
  CSContainer,
  CSHeader,
  CSOption,
  CSOptions,
  CSOptionText,
} from './components';
import { StyledLink } from '../../Footer/components';

/**
 * Renders the Customer Service component with various contact options.
 */
export const CustomerService = () => {
  const {
    session: { account, isAuthenticated },
  } = useSession();
  const {
    data: { supportEmail },
    links: { chatLink },
    images: { imgCustomerService },
  } = useAppConstantsContext();
  const memberId = account?.account.user_info.user_code || '';

  return (
    <CSContainer>
      <CSHeader>
        <Box>
          <img
            src={imgCustomerService}
            alt="Customer Service"
            style={{ height: '50px', width: '50px' }}
          />
        </Box>
        <Box>
          <CSOptionText>Contact Us</CSOptionText>
          <Text variant="body2">
            We pride ourselves on offering friendly and helpful support!
          </Text>
        </Box>
      </CSHeader>

      <CSOptions>
        <CSOption
          icon={<Icons.Chat color="primary" fontSize="small" />}
          title={
            <StyledLink
              href={chatLink}
              underline="always"
              target="_blank"
              rel="noreferrer noopener"
              color="success.main"
            >
              Chat with us live
            </StyledLink>
          }
          description="Available 24 hours"
        />

        <Divider />

        <CSOption
          icon={<Icons.Email color="primary" fontSize="small" />}
          title={
            <>
              <StyledLink
                href={`mailto:${supportEmail}`}
                underline="always"
                sx={{ overflowWrap: 'anywhere' }}
                color="success.main"
              >
                {supportEmail}
              </StyledLink>

              <CopyTooltip value={supportEmail} />
            </>
          }
          description="Available 24 hours"
        />

        {isAuthenticated && (
          <>
            <Divider />

            <CSOption
              icon={<Icons.AccountCircle color="primary" fontSize="small" />}
              title="Your member ID is"
              description={
                <CopyTooltip value={memberId}>{memberId}</CopyTooltip>
              }
              invertColors
            />
          </>
        )}
      </CSOptions>
    </CSContainer>
  );
};
